import "./CharList.css";
import { useEffect, useState } from "react";
import Loader from "../../Loader/Loader";
import { charAPI } from "../../../api/charAPI";
import { logger } from "../../../Services/LoggingService";
import { withAITracking } from "@microsoft/applicationinsights-react-js";
import { reactPlugin } from "../../../Services/AppInsightService";
import CharCard from "./CharCard";
import { IRpgCharacter } from "../../../models/IRpgCharacter";
import { useAuth } from "../../../auth/AuthContext";
import { useNavigate } from "react-router-dom";
import UiButton from "../../Buttons/UiButton";
import { saveCharToStorage } from "../../../pages/Characters/characterHelpers";

const CharList: React.FC = (charProps) => {
	const { user, userAuthenticated } = useAuth();
	const navigate = useNavigate();

    const [isLoading, setIsLoading] = useState(false);
    const [charList, setCharList] = useState<IRpgCharacter[]>([]);

    // useEffects
    useEffect(() => {
		if (!userAuthenticated || !user?.Id || user.Id <= 0) {
			setCharList([]);
			return;
		}

        getCharList(user.Id);
    }, [userAuthenticated, user?.Id]);

    // API calls
    const getCharList = (userId: number) => {
        setIsLoading(true);

        charAPI.getChars(userId)
        .then((ret: IRpgCharacter[]) => {
            setCharList(ret);
            setIsLoading(false);
            return ret;
        })
        .catch((err: any) => {
            logger.error("Error making get chars call:", err);
            setIsLoading(false);
        });
    };

    // Event Handlers
	const onCreateCharacter = () => {
		navigate("/characters/new");
	};

	const onViewCharacter = (characterId: number) => {
        saveCharToStorage(charList.find((char: IRpgCharacter) => char.Id === characterId));
		navigate(`/characters/${characterId}/view`);
	};

	const onEditCharacter = (characterId: number) => {
        saveCharToStorage(charList.find((char: IRpgCharacter) => char.Id === characterId));
		navigate(`/characters/${characterId}/edit`);
	};

	const onDeleteCharacter = async (characterId: number) => {
		// TODO: confirm modal
		// try {
		// 	setIsLoading(true);
		// 	await charAPI.deleteChar(characterId); // implement if not already
		// 	if (user?.Id && user.Id > 0) {
		// 		await getCharList(user.Id);
		// 	}
		// } catch (err: any) {
		// 	logger.error("Error deleting character:", err);
		// } finally {
		// 	setIsLoading(false);
		// }
	};

    return (
        <div className='char-list-control'>
            { isLoading ? 
                <Loader text="Getting Adventurer list..." /> 
            :
                <div>
                    <div className="char-list__header">
                        <h2>Your available Adventurers</h2>
                        <div className="char-list__actions">
                            <UiButton variant="rust" text="Create an Adventurer" onClickCallback={onCreateCharacter} />
                        </div>
                    </div>

                    <div className="char-list__content">
                        {charList.length === 0 ? "No Adventurers found." :
                            // TODO: if we want to add/support a table view
                            // <table border={0} cellPadding={5}>
                            //     {charList.map((char) => {
                            //         return <CharRow character = {char}
                            //             // RemoveChar = {OnClick_RemoveChar} 
                            //             // RetireChar = {OnClick_RetireChar}
                            //         />
                            //     })}
                            // </table>

                            // This is our Adventurer Card view
                            <div className="char-list__container">
                                <div className="char-list__grid">
                                    {charList.map((char) => {
                                        return <CharCard 
                                            key={char.Id}
                                            character = {char}
                                            onView={onViewCharacter}
                                            onEdit={onEditCharacter}
                                            onDelete={onDeleteCharacter}
                                        />
                                    })}
                                </div>
                            </div>
                        }
                    </div>
                </div>
            }
        </div>
    );
}

export default withAITracking(reactPlugin, CharList);
